var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconpubli2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19 18.4H22.99L18.73 12.79L14.95 17.8L12.19 14.41L9.19 18.4ZM4 28V5.8C4 5.32 4.18 4.9 4.54 4.54C4.9 4.18 5.32 4 5.8 4H26.2C26.68 4 27.1 4.18 27.46 4.54C27.82 4.9 28 5.32 28 5.8V21.4C28 21.88 27.82 22.3 27.46 22.66C27.1 23.02 26.68 23.2 26.2 23.2H8.8L4 28Z",
    fill: "#BED000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconpubli2);
export default __webpack_public_path__ + "static/media/iconpubli2.c130e54ca92e6e5b1613ae7a65bae3f5.svg";
export { ForwardRef as ReactComponent };